import $ from "jquery";

export const checkPurchaseType = () => {
    $(".radio--type").on('click', function () {
        const target = $(this);
        const orderFields = $('.payment-info-form--personal');
        const businessFields = $('.payment-info-form--business');

        if (target.attr('id') === 'radio-business') {
            orderFields.hide();
            businessFields.show();

        } else {
            orderFields.show();
            businessFields.hide();
        }
    });
};
